(function() {
  var thumbnails = document.querySelectorAll('[data-thumbnail-index]');
  var mainImg = document.getElementById('ame-product-main-img');
  if (!mainImg) return;

  var mediaDataEl = document.getElementById('ame-product-media-data');
  var rawMedia = [];
  if (mediaDataEl) { try { rawMedia = JSON.parse(mediaDataEl.textContent) || []; } catch (e) { rawMedia = []; } }
  // Skip promo/badge images (e.g. "Patented MaxiComfort Positioning") so the
  // JS index lines up with the thumbnails rendered by the Liquid template.
  var PROMO_ALT_RE = /(patent|positioning badge|maxicomfort positioning|fda class)/i;
  var media = rawMedia.filter(function (m) {
    return !PROMO_ALT_RE.test(m && m.alt ? m.alt : '');
  });
  if (media.length === 0) media = rawMedia;
  var total = media.length;
  var currentIndex = 0;

  var prevBtn = document.querySelector('[data-gallery-prev]');
  var nextBtn = document.querySelector('[data-gallery-next]');

  var videoHost = document.getElementById('ame-product-video-host');
  var thumbRail = document.querySelector('.ame-product__thumbnails');

  // Bring the active thumbnail into view WITHIN its own rail only. The old
  // code used element.scrollIntoView(), which scrolls every scrollable
  // ancestor INCLUDING the window — so every next/prev click yanked the whole
  // PDP up to the gallery top (Tom, 2026-07-17). This scrolls just the rail
  // (vertical column on desktop, horizontal strip on mobile) and never the
  // page, and only when the thumb is actually out of view.
  function scrollThumbIntoView(thumb) {
    if (!thumbRail || !thumb) return;
    var rail = thumbRail.getBoundingClientRect();
    var t = thumb.getBoundingClientRect();
    var vertical = thumbRail.scrollHeight > thumbRail.clientHeight + 1;
    if (vertical) {
      if (t.top < rail.top) thumbRail.scrollBy({ top: t.top - rail.top - 8, behavior: 'smooth' });
      else if (t.bottom > rail.bottom) thumbRail.scrollBy({ top: t.bottom - rail.bottom + 8, behavior: 'smooth' });
    } else {
      if (t.left < rail.left) thumbRail.scrollBy({ left: t.left - rail.left - 8, behavior: 'smooth' });
      else if (t.right > rail.right) thumbRail.scrollBy({ left: t.right - rail.right + 8, behavior: 'smooth' });
    }
  }

  function goToIndex(idx) {
    if (idx < 0 || idx >= total) return;
    currentIndex = idx;

    // Update main media (image, or a playable embed for video media)
    var m = media[idx];
    if (m) {
      var isYtVideo = m.media_type === 'external_video' && m.host === 'youtube' && m.external_id;
      if (videoHost && isYtVideo) {
        // User clicked the video thumbnail — play it in place of the image
        videoHost.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' +
          encodeURIComponent(m.external_id) + '?autoplay=1&rel=0" title="Product video" ' +
          'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
        videoHost.hidden = false;
        mainImg.style.display = 'none';
      } else {
        if (videoHost) { videoHost.hidden = true; videoHost.innerHTML = ''; }
        mainImg.style.display = '';
        // external/native video entries carry the image under preview_image
        var src = m.src || (m.preview_image && m.preview_image.src) || '';
        if (src) {
          mainImg.src = src.replace(/&width=\d+/, '&width=1000');
          mainImg.srcset = '';
        }
        mainImg.alt = m.alt || mainImg.alt;
      }
    }

    // Update thumbnails
    thumbnails.forEach(function(t) {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    if (thumbnails[idx]) {
      thumbnails[idx].classList.add('is-active');
      thumbnails[idx].setAttribute('aria-selected', 'true');
      scrollThumbIntoView(thumbnails[idx]);
    }

    // Update arrow states
    updateArrows();
  }

  function updateArrows() {
    if (prevBtn) prevBtn.disabled = (currentIndex <= 0);
    if (nextBtn) nextBtn.disabled = (currentIndex >= total - 1);
  }

  // Thumbnail click
  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      goToIndex(parseInt(this.dataset.thumbnailIndex, 10));
    });
  });

  // Arrow click
  if (prevBtn) prevBtn.addEventListener('click', function() { goToIndex(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goToIndex(currentIndex + 1); });

  // Keyboard navigation (Left/Right arrows when gallery is focused)
  var gallery = document.querySelector('.ame-product__gallery');
  if (gallery) {
    gallery.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        goToIndex(currentIndex - 1);
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        goToIndex(currentIndex + 1);
      } else if (e.key === 'Home') {
        e.preventDefault();
        goToIndex(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        goToIndex(total - 1);
      }
    });
  }

  // Touch swipe support on main image
  var imageWrap = document.querySelector('.ame-product__main-image-wrap');
  if (imageWrap) {
    var touchStartX = 0;
    var touchStartY = 0;
    imageWrap.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    imageWrap.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      // Only swipe if horizontal movement > 40px and > vertical movement
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) goToIndex(currentIndex + 1); // swipe left = next
        else goToIndex(currentIndex - 1);          // swipe right = prev
      }
    }, { passive: true });
  }

  // Variant → image switching (the size dropdown carries the variant id)
  var variantsEl = document.getElementById('ame-product-variants-data');
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantsEl) {
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) { variants = []; }
    var showVariantImage = function (vid) {
      var variant = variants.find(function (v) { return v.id === vid; });
      if (!variant || !variant.featured_media) return;
      for (var i = 0; i < media.length; i++) {
        if (media[i].id === variant.featured_media.id) { goToIndex(i); break; }
      }
    };
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        showVariantImage(parseInt(variantSelect.value, 10));
      });
    }
    /* ★ The color-chip / variant-card paths update the hidden input programmatically;
       ame-pdp-state announces those through this document event. The duplicate sticky
       panel means the changed input may not be the node queried above — the event
       carries the id, so node identity stops mattering. */
    document.addEventListener('ame:variant-change', function (e) {
      var vid = parseInt(e.detail && e.detail.id, 10);
      if (vid) showVariantImage(vid);
    });
  }

  // Initialize arrow states
  updateArrows();

  // Click-to-enlarge: main image opens the current media full-size in a
  // native <dialog> (Esc + backdrop close come free and stay accessible)
  var lightbox = document.querySelector('[data-gallery-lightbox]');
  var panel = document.getElementById('ame-product-image-panel');
  if (lightbox && panel && typeof lightbox.showModal === 'function') {
    var lbImg = lightbox.querySelector('[data-lightbox-img]');
    function openLightbox() {
      var img = panel.querySelector('img');
      if (!img || !img.src || !lbImg) return;
      var full = (img.currentSrc || img.src).replace(/width=\d+/, 'width=2000');
      lbImg.src = full;
      lbImg.alt = img.alt || '';
      lightbox.showModal();
    }
    panel.addEventListener('click', openLightbox);
    // The panel is a tabpanel, so the enlarge affordance is a real button —
    // without it the lightbox is unreachable by keyboard.
    var zoomBtn = panel.querySelector('[data-gallery-zoom]');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openLightbox();
      });
    }
    lightbox.addEventListener('click', function (e) {
      // click on the backdrop (the dialog element itself) closes
      if (e.target === lightbox) lightbox.close();
    });
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { lightbox.close(); });
  }
})();
